import * as yup from 'yup';
import { isStringArray } from '../common.ts';

const stringArraySchema = yup.array().of(yup.string().required());
const objectArraySchema = yup.array().of(
  yup.object({
    id: yup.string().required(),
    value: yup.string().required(),
  })
);

export const validateNameArray = (value: unknown): string[] => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return [];
  }

  try {
    if (!Array.isArray(value)) {
      throw new Error(`Value must be an array, received: ${typeof value}`);
    }

    if (isStringArray(value)) {
      return stringArraySchema.validateSync(value) ?? [];
    }

    return (objectArraySchema.validateSync(value) ?? []).map((item) => item.value);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Validation error:', error);
    return [];
  }
};
